import Errors              from '$/lib/Errors';
import { JSONTransformer } from '$/lib/columnTransformers';
import { Platform }        from '$/lib/env';

import { Column, Entity, ManyToOne } from '$/entities/BaseEntity';
import { BaseRole }                  from '$/entities/roles/BaseRole';
import { ChatMessage }               from '$/entities/chat/ChatMessage';
import { LandlordAssistProperties }  from '$/entities/LandlordAssistFile';
import { BaseOrgEntity }             from '$/entities/Organization';
import Permissions, { Context }      from '$/entities/lib/Permissions';
import type { FileStore }            from '$/entities/FileStore';
import { PackageFeature }            from '$/entities/PackageExt';

export enum ChatStreamEventType {
	Connected    = 'connected',
	MessageChunk = 'messageChunk',
	Done         = 'done',
	Error        = 'error',
}

@Entity('chatThread', { common : true })
@Permissions({
	read  : Permissions.roleHasFeature(PackageFeature.LandlordAssist),
	write : Permissions.roleHasFeature(PackageFeature.LandlordAssist),
})
export class ChatThread extends BaseOrgEntity {

	constructor(initValues?: Partial<ChatThread>) {
		super();
		this.mergeColumns(initValues);
	}

	@ManyToOne('BaseRole', { onDelete : 'CASCADE' })
	@Permissions({ write : Permissions.isNew })
	createdBy: BaseRole;

	@Column({ type : 'json', default : () => "('[]')", transformer : JSONTransformer({ jsonable : ChatMessage }) })
	@Permissions({
		write : (context: Context, entity: ChatThread) => {
			if (entity.isNew) {
				return _.if(context.platform === Platform.Client && entity.messages.some(message => message.isAssistant),
					'cannot add assistant messages'
				);
			}

			return Permissions.serverOnly(context, entity);
		},
	})
	messages: ChatMessage[] = [];

	@Column({ type : 'json', default : () => "('{}')" })
	@Permissions({ write : Permissions.isNew })
	properties: LandlordAssistProperties = new LandlordAssistProperties();

	@Column()
	name: string = '';

	addMessage(message: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
		throw new Errors.NotImplemented();
	}

	getAIResponse(fileStore?: FileStore) { // eslint-disable-line @typescript-eslint/no-unused-vars
		throw new Errors.NotImplemented();
	}

	removeMessage(index: number) { // eslint-disable-line @typescript-eslint/no-unused-vars
		throw new Errors.NotImplemented();
	}

	clearMessages() {
		throw new Errors.NotImplemented();
	}

}
